import { useEffect, useState } from "react";
import { scanQueue, type QueuedScan } from "@/offline/scanQueue";

/**
 * Live view of held-but-unread receipt photos (build tasks #1/#2). Mirrors
 * `useOutbox` exactly — read-only subscription onto the singleton queue,
 * which is the one source of truth for what's pending.
 */
export function useScanQueue(): QueuedScan[] {
  const [items, setItems] = useState<QueuedScan[]>([]);

  useEffect(() => {
    let cancelled = false;
    scanQueue.list().then((list) => {
      if (!cancelled) setItems(list);
    });
    const unsubscribe = scanQueue.subscribe((list) => {
      if (!cancelled) setItems(list);
    });
    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, []);

  return items;
}
